// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"99e4f61b","455":"f7dd8b2d","977":"a04f8ec6"}[chunkId] + ".chunk.js";
};